import React from "react";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
import { destroy } from "ducks/filters";
import { connect } from "react-redux";
import ConfirmModal from "components/ConfirmModal";
const DestroyPropertyTemplate = ({ destroy, id }) => {
  const closeDestroyModal = useRemoveQueryNavigation("deleteFilter");

  return (
    <ConfirmModal
      title="Filter löschen"
      confirm={() => {
        destroy(id);
        closeDestroyModal();
      }}
      close={closeDestroyModal}
    />
  );
};

export default connect(null, { destroy })(DestroyPropertyTemplate);
